import React from 'react';
import { Button } from '@mui/material'; 
import { CustomButtonProps } from './customButtonProps';

const CustomButton: React.FC<CustomButtonProps> = ({ className,children, onClick, type = "submit", style, startIcon }) => (
  <Button
    fullWidth
    variant="contained"
    sx={{ mt: 3, mb: 2, typography: 'button',fontWeight: 'bold',  ...style }} 
    onClick={onClick} 
    type={type}
    startIcon={startIcon} 
    className={className} 
  >
    {children}
  </Button>
);

export default CustomButton;
